import { defineComponent as _defineComponent } from 'vue'
import { Message } from 'element-ui'
import { ref, computed, PropType } from 'vue'
import { updateResultAPI } from '@/api/mt/index'
import BaseElScrollbar from './BaseElScrollbar.vue'
import { cloneDeep } from 'lodash'
import scrollIntoView from 'scroll-into-view-if-needed'
import { copyText } from '@/utils/jClipboard'
import { IMtRes } from '@/api/mt/type'
import $ from 'jquery'


export default /*#__PURE__*/_defineComponent({
  __name: 'TranslateContent',
  props: {
  translateRes: {
    type: Object as PropType<IMtRes.ITranslateRes>,
    required: true
  }
},
  emits: ['edit-res'],
  setup(__props, { expose, emit: emits }) {

const props = __props




// 原文和翻译结果对应的索引
const currentIndex = ref(-1)

// 存储翻译结果容器dom数组
const resultsDomRef: HTMLSpanElement[] = []
// 存储原文容器dom数组
const originDomsRef: HTMLSpanElement[] = []
const resultsSetRef = (el: any) => {
  resultsDomRef.push(el)
}
const originSetRef = (el: any) => {
  originDomsRef.push(el)
}
const originalName = computed(() => {
  if (props.translateRes !== undefined) {
    const { name } = props.translateRes
    return name
  }
  return ''
})

const translatedName = computed(() => {
  return props.translateRes.des ? `翻译结果 ${props.translateRes.des}` : ''
})

const isEdit = ref(false)
function handleEditRes(v: boolean) {
  isEdit.value = v
  emits('edit-res', v)
}

// 悬浮文本行
function clickAudioText (index: number, event: any) {
  if (currentIndex.value) {
    currentIndex.value = index
    scrollCenter(event.target.dataset.type, currentIndex.value)
  }
}

// 滑动页面到中间
function scrollCenter (type: string, currentIndex: number) {
  if (type === 'origin') {
    scrollIntoView(resultsDomRef[currentIndex], { block: 'center', inline: 'center' })
  } else {
    scrollIntoView(originDomsRef[currentIndex], { block: 'center', inline: 'center' })
  }
}

function handleKeyUp() {
  const select = window.getSelection()
  const spanDOM = select?.getRangeAt(0).endContainer.parentElement
  const index = spanDOM?.id.split('_')[1]
  currentIndex.value = Number(index)
  if (!spanDOM?.dataset.type) return
  scrollCenter(spanDOM.dataset.type, currentIndex.value)
}

// 离开文本行
function leaveText () {
  currentIndex.value = -1
}

function handleCopy () {
  const txt = $('.edit-wrapper').text()
  copyText(txt)
    .then(() => {
      Message.success('复制成功')
    })
    .catch((e) => {
      Message.error('复制失败')
      console.log(e)
    })
}

async function handleSave () {
  const { id, segments } = props.translateRes
  segments.forEach((element: any, index: number) => {
    element.translated = $('#span_' + index).html()
  })
  // 区分用户是在译文修改还是删掉重新输入
  if ($('.edit-wrapper span').attr('data-type') === 'translate') {
    // 用户输入的文本加到最后一句
    const inputText = $('.edit-wrapper div').text()
    const newText = cloneDeep(segments)
    newText[newText.length - 1].translated += inputText
    await updateResultAPI({
      id,
      content: newText
    })
    emits('edit-res', false)
    isEdit.value = false
    Message.success('保存成功')
  } else {
    const newOriginText = segments.map((item: any) => item.origin).toString()
    const newJsonContent = [
      {
        origin: newOriginText,
        translated: $('.edit-wrapper').text()
      }
    ]
    await updateResultAPI({
      id,
      content: newJsonContent
    })
    emits('edit-res', false)
    Message.success('保存成功')
  }
}

expose({
  handleSave
})

return { __sfc: true,props, emits, currentIndex, resultsDomRef, originDomsRef, resultsSetRef, originSetRef, originalName, translatedName, isEdit, handleEditRes, clickAudioText, scrollCenter, handleKeyUp, leaveText, handleCopy, handleSave, BaseElScrollbar }
}

})